import { useCallback } from "react";
import { generatePath, useNavigate } from "react-router";

import { PATHS } from "@/routes/paths";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";
import { useLoadingScreen } from "@/components/features/side-effect/show-loading-screen-to-user/_hooks/use-loading-screen";

import { viewModelToPlanInputConverter } from "../../../repository/existing/mutation/composition";
import { useCreatePlanMutation } from "../../../repository/new/mutation";
import { viewModelToPlanCustomMailSettingInputConverter } from "../../../repository/new/mutation/composition";

import type { ProductPlanFormModel } from "../../../type";

type Props = {
	viewModel: ProductPlanFormModel["ViewModel"];
	onReset: () => void;
};

export const useCreatePlan = ({ viewModel, onReset }: Props) => {
	const navigate = useNavigate();
	const { showLoadingScreenCallback, hideLoadingScreenCallback } = useLoadingScreen();
	const { onCreatePlan: _onCreatePlan } = useCreatePlanMutation();
	/**
	 * @todo 副作用を UI で定義
	 */
	const onCreatePlan = useCallback(async () => {
		showLoadingScreenCallback();

		try {
			const planInput = viewModelToPlanInputConverter({ viewModel });
			const planCustomMailSettingInput = viewModelToPlanCustomMailSettingInputConverter({ viewModel });

			// プラン作成
			const { errors: planErrors } = await _onCreatePlan(planInput, planCustomMailSettingInput);

			if (planErrors) {
				return;
			}

			if (!planErrors) {
				notifyUserEventInfo({
					title: "プランを作成しました",
				});
				onReset();
				const hotelID = planInput.hotelID;
				setTimeout(() => navigate(generatePath(PATHS.HOTEL.ITEMS.PLAN.TOP, { hotelID })), 300);
			}
		} finally {
			hideLoadingScreenCallback();
		}
	}, [_onCreatePlan, hideLoadingScreenCallback, navigate, onReset, showLoadingScreenCallback, viewModel]);

	return { onCreatePlan };
};
